<template>
  <div class="homeCon">
    <div class="home">
      <div
        v-if="showPeople && mourningTime && peopleRoute"
        v-show="barShow"
        :class="{ mourningGrey: mourningTime && showPeople && peopleRoute }"
        class="people-header-mourning"
      >
        深切哀悼抗击新冠肺炎疫情斗争牺牲烈士和逝世同胞
        <i class="el-icon-close" @click="closeBar"></i>
      </div>
      <div
        class="people-header"
        v-if="showPeople"
        :class="{ mourningGrey: mourningTime && showPeople && peopleRoute }"
      >
        <div>
          <a href="http://www.people.com.cn/" target="_blank">
            <img
              src="../../static/images/people/people-logo-2.png"
              style="height:50px;"
            />
          </a>
        </div>
      </div>
      <div
        class="homeHeaderCon"
        v-if="hiddenNav"
        :class="{ mourningGrey: mourningTime && showPeople && peopleRoute }"
      >
        <div
          :class="['homeHeaderP', { transP: isModelSix }]"
          :style="{ 'background-color': homeheaderbgcolor }"
        >
          <div class="homeHeader">
            <div
              class="logo"
              @click="gofirstPage"
              :style="{ width: ifCpad ? 'auto' : '120px' }"
            >
              <img
                :class="{ beijing2022: isshowregis, other: !isshowregis }"
                v-if="logosrc"
                :src="logosrc"
                alt="logo"
                style="cursor:pointer"
                :style="{
                  'max-width': ifCpad
                    ? this.webID == '111142' ||
                      this.webID == '111124' ||
                      this.webID == '111130' ||
                      this.webID == '111147' ||
                      this.webID == '111148'
                      ? '800px'
                      : '120px'
                    : '120px',
                  'max-height': ifCpad ? '66px' : '60px',
                  cursor: 'pointer'
                }"
              />
            </div>
            <div class="otherCon" :style="{ 'justify-content': navpos }">
              <div class="nav">
                <ul class="nav-content">
                  <!-- 此处为高能所改变了page_name -->
                  <li
                    v-for="(item, index) in modelsInfo_real"
                    v-if="item.status == 1"
                    :key="index"
                  >
                    <a
                      :class="{
                        activeSty: index == activeChanelIndex,
                        noactiveSty: index != activeChanelIndex,
                        disable: item.page_name == '视频素材11222211',
                        sjcaLine: (showChangAn || isgehuaVcg) == true
                      }"
                      @click="changeModel(item, index)"
                      :style="{
                        color:
                          showChangAn || isgehuaVcg ? '#fff' : 'rgba(8,8,8,1)',
                        cursor: 'pointer'
                      }"
                      v-text="
                        isGaonS
                          ? isEnglish &&
                            (item.page_name || '').indexOf('*##*') != -1
                            ? (item.page_name || '').split('*##*')[1]
                            : (item.page_name || '').split('*##*')[0]
                          : item.page_name
                      "
                    ></a>
                  </li>
                  <li v-if="showPeople" style="margin-left:20px">
                    <a
                      class="noactiveSty"
                      style="color: rgb(51, 51, 51); cursor: pointer; display:inline-block; border-left:1px solid #D8D8D8; padding-left: 20px;"
                      href="http://vip.people.com.cn/daily/publish"
                      target="_blank"
                      >人民日报见报图片</a
                    >
                  </li>
                  <li v-if="showPeople">
                    <a
                      class="noactiveSty"
                      style="color: rgb(51, 51, 51); cursor: pointer;"
                      href="http://vip.people.com.cn/daily/rank/abord"
                      target="_blank"
                      >海外版见报图片</a
                    >
                  </li>
                  <li v-if="showPeople">
                    <a
                      class="noactiveSty"
                      style="color: rgb(51, 51, 51); cursor: pointer;"
                      target="_blank"
                      href="http://vip.people.com.cn/channel/listAlbumsByChannel?channelId=20&channelName=%E5%9B%BE%E7%89%87%E6%95%85%E4%BA%8B#page=1 "
                      >图片故事</a
                    >
                  </li>
                  <li v-if="showPeople">
                    <a
                      class="noactiveSty"
                      style="color: rgb(51, 51, 51); cursor: pointer;"
                      target="_blank"
                      href="http://vip.people.com.cn/topic/listTopTopics#page=1 "
                      >专题策划</a
                    >
                  </li>
                  <li v-if="payment == 1" class="first-menu">
                    <router-link to="/PackagePrice">套餐价格</router-link>
                  </li>
                </ul>
              </div>
            </div>
            <div
              style="display: flex; align-items: center; justify-content: flex-end;"
            >
              <!-- <div
                v-if="this.isGaonS"
                style="margin:10px; width:80px; text-align:center;"
              >
                <el-button
                  type="text"
                  @click="switchEng"
                  style="color:#ffd04b;"
                  >{{ isEnglish ? "中文" : "English" }}</el-button
                >
              </div> -->
              <div
                v-if="showPeople"
                style="margin:0 20px 0 0;width:80px;text-align:center;"
              >
                <el-button
                  type="text"
                  @click="toPeoplePicture"
                  style="width:84px;font-size:14px;font-family:PingFangSC-Regular,PingFang SC;font-weight:400;color:rgba(215,0,15,1);"
                  class="peoplePicture"
                  >访问人民图片</el-button
                >
              </div>
              <div
                v-if="showPeople"
                style="margin:0 20px 0 0;width:1px;text-align:center;"
              >
                <el-button
                  type="text"
                  style="width:1px;font-size:14px;font-family:PingFangSC-Regular,PingFang SC;font-weight:400;color:#D8D8D8;"
                  class="peoplePicture"
                  >|</el-button
                >
              </div>
              <div class="loginBtn" v-if="!userInfo && isOuthtoken">
                <div class="btnContent">
                  <a class="sogin" :href="redictUrl">
                    {{
                      isGaonS
                        ? isEnglish
                          ? "Unified identity authentication"
                          : "统一认证登录"
                        : "统一认证登录"
                    }}
                  </a>
                </div>
              </div>
              <div class="loginBtn" v-if="!userInfo">
                <div class="btnContent">
                  <div
                    style="margin-right:5px"
                    class="iconfont icon-Shapecopy"
                  ></div>
                  <div class="loginbtn-item">
                    <router-link class="login-left" to="/login"
                      >登录</router-link
                    >
                  </div>
                  <div>/</div>
                  <div class="loginbtn-item">
                    <router-link class="login-right" to="/register"
                      >注册</router-link
                    >
                  </div>
                </div>
              </div>
              <div class="userPerson userInfo" v-else>
                <el-dropdown
                  trigger="hover"
                  placement="top"
                  v-if="userInfo"
                  @visible-change="handleCommand($event)"
                >
                  <div class="personLogo">
                    <span
                      :style="{
                        color: showChangAn || isgehuaVcg ? '#fff' : '#333'
                      }"
                    >
                      {{ userInfo.user_name }}
                      <i class="el-icon-arrow-down drop-menu-arrow"></i>
                    </span>
                    <a class="userHead" v-if="!isshowregis">
                      <img :src="userInfo.img_path" alt />
                    </a>
                  </div>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item>
                      <span @click="toPersonal">
                        {{
                          isGaonS
                            ? isEnglish
                              ? "Personal Center"
                              : "个人中心"
                            : "个人中心"
                        }}
                      </span>
                    </el-dropdown-item>
                    <el-dropdown-item v-show="picshow == true">
                      <span @click="toDam">
                        {{
                          isGaonS
                            ? isEnglish
                              ? "Graph Storehouse Management"
                              : "图库管理"
                            : "图库管理"
                        }}
                      </span>
                    </el-dropdown-item>
                    <el-dropdown-item v-if="isVCGPermission">
                      <span @click="toVCG">VCG+</span>
                    </el-dropdown-item>
                    <el-dropdown-item v-if="!ifChildSite">
                      <span @click="signOut">
                        {{
                          isGaonS
                            ? isEnglish
                              ? "Sign Out"
                              : "退出登录"
                            : "退出登录"
                        }}
                      </span>
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- <changan-nav v-if="hiddenNav && showChangAn"></changan-nav> -->
      <div class="routerview">
        <router-view :key="key"></router-view>
      </div>
    </div>
    <div
      v-if="isshowSidebar"
      class="righttoolbal"
      :class="{ mourningGrey: mourningTime && showPeople }"
    >
      <div class="itemcon">
        <div class="tel" @mouseover="mouseoverT" @mouseout="mouseoutT">
          <div>
            <div class="iconfont icon-erji" style="text-align:center"></div>
            <div style="text-align:center">购</div>
            <div style="text-align:center">买</div>
            <div style="text-align:center">咨</div>
            <div style="text-align:center">询</div>
          </div>
          <!--  -->
          <div v-if="TelInfoShow" class="telinfo">
            <!-- <div>Tel:</div> -->
            <div>联系电话:</div>
            <div>&nbsp;&nbsp;{{ sidebarTel }}</div>
            <div>工作时间:</div>
            <div>&nbsp;&nbsp;{{ sidebarTime }}</div>
            <!-- <div>����:14:30-17:30</div> -->
          </div>
        </div>
        <!-- <div class="collection" @click="toPersonal(1)" @mouseover="mouseoverC" @mouseout="mouseoutC">
          <div :class="[{collec:collectionShow},'iconfont','icon-shoucang']" style="text-align:center"></div>
          <div class="collectioninfo" v-if="collectionShow">收藏夹</div>
        </div>
        <div class="download" @click="toPersonal(2)" @mouseover="mouseoverD" @mouseout="mouseoutD">
          <div :class="[{jilu:downloadShow},'iconfont','icon-lishijilu']" style="text-align:center"></div>
          <div class="downloadinfo" v-if="downloadShow">下载记录</div>
        </div>-->
        <div
          class="download"
          @click="toOnlineService"
          v-if="showPeople"
          @mouseover="mouseoverService"
          @mouseout="mouseoutService"
        >
          <div
            :class="[{ jilu: downloadShow }]"
            style="text-align:center;cursor:pointer;
          "
          >
            <img width="20" style src="../../static/images/icon.png" />
          </div>
          <div class="downloadinfo" v-if="downloadShow">在线客服</div>
        </div>
        <div class="txqq" style="text-align:center" v-if="!showPeople">
          <a
            target="_blank"
            :href="
              'http://wpa.qq.com/msgrd?v=3&uin=' +
                sidebarQQ +
                '&site=qq&menu=yes'
            "
          >
            <div
              class="txqqcon"
              @mouseover="mouseoverQQ"
              @mouseout="mouseoutQQ"
            >
              <div
                :class="[{ qq: qqcom }, 'iconfont', 'icon-qq']"
                style="color:white"
              ></div>
              <div class="qqcom" v-if="qqcom">QQ客服</div>
            </div>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import modelTwoNew from "./modelTwoNew.vue";
import homeHeader from "../components/homeHeader.vue"; //头部
import modelAd from "./modelAd.vue";
import allClassification from "./allClassification.vue";
import modelOne from "./modelOne.vue";
import modelTwo from "./modelTwo.vue";
import modelThree from "./modelThree.vue";
import modelAdBeforeLogin from "./modelAdBeforeLogin.vue";
import recommend from "./recommend.vue";
import valueaddservice from "./valueaddservice.vue";
import aboutUs from "./aboutUs.vue";
import topic from "./topic.vue";
import { mapActions, mapGetters, mapState } from "vuex";
import imgCardVue from "../components/imgCard.vue";
import ChanganNav from "../components/changanNav.vue";
import detectDeviceType from "../utils/detectDeviceType";
import dateJudge from "../utils/dateJudge";

import Axios from "axios";
import {
  getModulStyle,
  getWebModels,
  getModuleInfo,
  getdoctitle,
  signOut,
  getwebid,
  getSiteLogin,
  loginThrougUser,
  getUserInfo
} from "@/services/api.js";
import pbmethod from "../publicmethod.js";
export default {
  data() {
    return {
      payment: "",
      picshow: false, //图库管理是否显示
      ifChildSite: false, //是否子站点
      webID: 1,
      isOuthtoken: false,
      redictUrl: "http://gaonengsuo.my/gnsAuth",
      sidebarQQ: "",
      sidebarTel: "",
      sidebarTime: "",
      isshowSidebar: false,
      userInfo: false,
      modelShow: 1,
      opacity: "0.68",
      TelInfoShow: false,
      collectionShow: false,
      downloadShow: false,
      qqcom: false,
      navpos: "center",
      select: "0",
      searchText: "",
      homeColor: {
        id: "",
        list: [{ body: "rgba(255,255,255)" }]
      },
      logo: {
        id: "",
        list: [{ photo1: "" }]
      },
      realopacity: this.opacity,
      homeheaderbgcolor: "rgba(255,255,255)",
      keyI: 0,
      modelsInfo_real: [],
      isModelSix: false,
      isLyLogin: false,
      hiddenNav: false,
      mustLogin: null,
      mustLoginEnd: false,
      showUploadAndQuery: false, //判断权限
      isVCGPermission: false, //是否拥有跳转到VCG+的
      isgehuaVcg: false, //是否是歌华（改变头部样式）
      ifCpad: false,
      uidYsf: "",
      nameYsf: "",
      emailYsf: "",
      mobileYsf: "",
      levelYsf: 1,
      groupidYsf: 398178311,
      robotIdYsf: "",
      barShow: true
    };
  },
  watch: {
    router_change: {
      handler(val) {
        //待完善
      }
    },
    login_success: {
      handler(val) {
        // console.log("登录成功了吗?", val);
        this.userInfo = sessionStorage.getItem("user")
          ? JSON.parse(sessionStorage.getItem("user"))
          : false;
        // user_type  类型1，注册用户，2内部用户，3供稿人，4签约用户，5内部供稿人，6编辑，7管理员
        if (this.userInfo) {
          let userroles = [3, 5, 6, 7];
          let user_type = this.userInfo.user_type;
          if (userroles.includes(user_type)) {
            this.showUploadAndQuery = true;
          }
          if (this.userInfo.user_type == 6 || this.userInfo.user_type == 7) {
            this.picshow = true;
          } else {
            this.picshow = false;
          }
        } else {
          localStorage.removeItem("vcgtoken");
        }
      },
      immediate: true
    },
    "curModelInfo.tpl_id": {
      handler() {
        window.scrollTo(0, 0);
      },
      deep: true
    },
    keyI(val) {
      if (val == 13) {
        this.toSearch();
      }
    },
    vcgpermissionss: {
      handler(val) {
        // debugger;
        if (val) {
          this.isVCGPermission = true;
        }
      },
      immediate: true
    },
    modelsInfo(val, oldval) {
      console.log("val", val);
      console.log("oldval", oldval);
      val.forEach(item => {
        item["path"] = this.getPathByTplId(item);
        this.modelsInfo_real.push(item);
      });
      //存入sessionStorage
      sessionStorage.setItem(
        "channelInfo",
        JSON.stringify(this.modelsInfo_real)
      );
      if (!sessionStorage.getItem("first")) {
        sessionStorage.setItem("first", 0);
        if (this.showPeople) {
          if (this.userInfo) {
            sessionStorage.setItem("fitstPath", this.modelsInfo_real[0].path);
          } else {
            sessionStorage.setItem("fitstPath", "peoplevisual");
          }
        } else {
          sessionStorage.setItem("fitstPath", this.modelsInfo_real[0].path);
        }
        this.setCurModelInfo(val[0]);
        let url = window.location.href;
        if (
          url == "http://sjca.vcg.com/" ||
          url == "http://sjca.vcg.com/noLoginModel"
        ) {
          console.log("阻挡了");
          return;
        }

        // 人民视觉
        if (
          url == "http://people.vcg.com/" ||
          url == "http://people.vcg.com/peoplevisual" ||
          url == "https://people.vcg.com/" ||
          url == "https://people.vcg.com/peoplevisual" ||
          url == "http://people-v.vcg.com/" ||
          url == "http://people-v.vcg.com/peoplevisual" ||
          url == "https://people-v.vcg.com/" ||
          url == "https://people-v.vcg.com/peoplevisual" ||
          url == "https://visual.people.cn/" ||
          url == "https://visual.people.cn" ||
          url == "http://visual.people.cn" ||
          url == "http://visual.people.cn/" ||
          url == "https://visual.people.cn/peoplevisual" ||
          url == "https://visual.people.com.cn" ||
          url == "https://visual.people.com.cn/peoplevisual"
        ) {
          console.log("阻挡了");
          return;
        }
        let timer = setTimeout(() => {
          if (this.mustLogin && this.mustLoginEnd) {
            this.$router.push({ path: "/login" });
          } else {
            this.$router.push({ path: "/" + this.modelsInfo_real[0].path });
          }
          clearTimeout("timer");
        }, 1000);
      } else {
        if (this.showPeople) {
          console.info("this.$route.path-------", this.$route.path);
          if (this.$route.path == "/modelvideo2") {
            sessionStorage.setItem("first", 1);
          }
          if (this.$route.path == "/modelthree") {
            sessionStorage.setItem("first", 0);
          }
        }

        let sindex = sessionStorage.getItem("first");
        this.setActiveChanelIndex(sindex);

        this.setCurModelInfo(val[sindex]);
      }
    },
    realopacity() {
      if (this.realopacity == "1") {
        this.homeheaderbgcolor = pbmethod.colorRgb(this.homeColor.list[0].body);
      } else {
        this.homeheaderbgcolor = pbmethod.colorRgb(
          this.homeColor.list[0].body,
          "0.5"
        );
      }
    },
    $route: "judgeHelp",
    mustLogin(val) {
      this.mustLoginEnd = true;
      let user = sessionStorage.getItem("user");
      let ifChangan = sessionStorage.getItem("ifChangan");
      let ifPeople = sessionStorage.getItem("ifPeople");

      if (ifChangan) {
        if (val && !user) {
          // console.log("设置了必须登录，并且还没有登录");
          this.$router.push({ path: "/noLoginModel" });
        } else {
          // console.log("没有设置必须登录，或者已经登录");
        }
      } else {
        if (val && !user) {
          // console.log("设置了必须登录，并且还没有登录");
          this.$router.push({ path: "/login" });
        } else {
          // console.log("没有设置必须登录，或者已经登录");
        }
      }

      if (this.showPeople) {
        if (val && !user) {
          // console.log("设置了必须登录，并且还没有登录");
          this.$router.push({ path: "/peoplevisual" });
        } else {
          // console.log("没有设置必须登录，或者已经登录");
        }
      } else {
        if (val && !user) {
          // console.log("设置了必须登录，并且还没有登录");
          this.$router.push({ path: "/login" });
        } else {
          // console.log("没有设置必须登录，或者已经登录");
        }
      }
    }
  },
  props: {
    issearch: {
      type: Boolean,
      default() {
        return true;
      }
    }
  },
  mounted() {
    this.payment = window.localStorage.getItem("payment"); // 1 支付开, 0 关闭支付
    let url = window.location.href;
    // http://sjca.vcg.com/   http://localhost:8080/
    if (url == "http://sjca.vcg.com/" || url == "http://sjca.vcg.com") {
      //视觉长安
      this.$router.push({ path: "/noLoginModel" });
    }

    if (
      (url == "http://people.vcg.com/" ||
        url == "http://people.vcg.com" ||
        url == "https://people.vcg.com" ||
        url == "https://people.vcg.com/" ||
        url == "http://people-v.vcg.com/" ||
        url == "http://people-v.vcg.com" ||
        url == "https://people-v.vcg.com" ||
        url == "https://people-v.vcg.com/" ||
        url == "https://visual.people.cn/" ||
        url == "https://visual.people.cn" ||
        url == "http://visual.people.cn/" ||
        url == "http://visual.people.cn" ||
        url == "https://visual.people.com.cn/" ||
        url == "https://visual.people.com.cn" ||
        url == "http://visual.people.com.cn/" ||
        url == "http://visual.people.com.cn" ||
        url == "https://people.vcg.com/" ||
        url == "https://people.vcg.com/" ||
        url == "https://people-v.vcg.com/" ||
        url == "http://localhost:8080" ||
        url == "http://localhost:8080/") &&
      !this.userInfo
    ) {
      // 人民视觉
      this.$router.push({ path: "/peoplevisual" });
    }
  },
  created() {
    let url = window.location.href.split("/");
    if (url[2] == "gehua.vcg.com") {
      this.isgehuaVcg = true;
    } else {
      this.isgehuaVcg = false;
    }
    if (!sessionStorage.getItem("user")) {
      localStorage.removeItem("vcgtoken");
    } else {
      let vcgToken = localStorage.getItem("vcgtoken");
      if (vcgToken) {
        this.isVCGPermission = true;
      }
    }

    getwebid({ domainName: window.location.host }).then(data => {
      if (data) {
        this.webID = data.data;
        this.CUSTOMERIDARR.CHANG_AN_ID;
        if (this.webID == this.CUSTOMERIDARR.CHANG_AN_ID) {
          //如果是视觉长安
          this.changeChangAn(true);
          if (this.showChangAn) {
            sessionStorage.setItem("ifChangan", this.showChangAn);
          }
          // console.log("changan", this.showChangAn);
        }
        if (this.webID == this.CUSTOMERIDARR.PEOPLE_ID) {
          //如果是人民视觉
          this.changePeople(true);
          if (this.showPeople) {
            sessionStorage.setItem("ifPeople", this.showPeople);
          }
          // console.log("changan", this.showChangAn);
        }
        // 111142(扶贫办)   111124(张家口冬奥会) 111130(北京冬奥会) 111148(广州恒大) 111147(资生堂)
        if (
          this.webID == 111142 ||
          this.webID == 111124 ||
          this.webID == 111130 ||
          this.webID == 111147 ||
          this.webID == 111148
        ) {
          this.ifCpad = true;
        }
        // this.keyevent();
        this.getModuleInfo();
        this.getdoctitle();
      }
    });
    if (this.$route.query.text) {
      this.select = this.$route.query.type;
      this.searchText = decodeURI(this.$route.query.text);
    }

    // 设置token
    this.getSiteChild();
  },
  computed: {
    peopleRoute() {
      return this.$route.path == "/peoplevisual";
    },
    mourningTime() {
      return dateJudge.isDuringDate(
        "2020/04/04 00:00:00",
        "2020/04/04 23:59:59"
      );
    },
    key() {
      return this.$route.path + Math.random();
    },
    router_change() {
      //获取一下频道id
      // console.log("获取一下频道id", this.curModelInfo.id);
      return this.$route;
    },
    vcgpermissionss() {
      return localStorage.getItem("vcgtoken");
    },
    isshowregis() {
      return (
        window.location.href.includes("39.97.23.148") ||
        window.location.href.includes("zjkda")
      );
    },
    logosrc() {
      if (this.logo.list.length > 0) {
        this.setLogoSrc(this.logo.list[0].photo1);
        return this.logo.list[0].photo1;
      } else {
        this.setLogoSrc("");
        return "";
      }
    },
    ...mapGetters([
      "modelsInfo",
      "webModels",
      "curModelInfo",

      "activeChanelIndex",
      "login_success",
      "showSite",
      "isGaonS",
      "isEnglish",
      "showChangAn",
      "showPeople"
    ])
  },
  methods: {
    ...mapActions([
      "setCurModelInfo",
      "setWebModels",
      "setActiveChanelIndex",
      "setLogoSrc",
      "setLoginSign",
      "changeSite",
      //是否是高能所
      "setisGaonS",
      //是否是英文
      "setisEnglish",
      //是否是视觉长安
      "changeChangAn",
      //是否是人民视觉
      "changePeople"
    ]),
    closeBar() {
      this.barShow = false;
    },
    handleCommand(event) {
      var el = document.querySelector(".drop-menu-arrow");

      if (event) {
        el.classList.remove("el-icon-arrow-down");
        el.classList.add("el-icon-arrow-up");
      } else {
        el.classList.remove("el-icon-arrow-up");
        el.classList.add("el-icon-arrow-down");
      }
    },
    switchEng() {
      this.setisEnglish(!this.isEnglish);
    },
    toOnlineService() {
      if (global.isSdkReady) {
        global.ysf &&
          global.ysf("config", {
            uid: this.uidYsf || "",
            name: this.nameYsf || "",
            email: this.emailYsf || "",
            mobile: this.mobileYsf || "",
            groupid: this.groupidYsf,
            robotId: this.robotIdYsf,
            data: JSON.stringify([
              {
                index: "1",
                key: "accountName",
                label: "客户名称",
                value: this.userInfo.user_name || "游客"
              }
            ]),
            robotShuntSwitch: 0,
            success() {
              // 成功回调
              if (detectDeviceType() === "Mobile") {
                location.href = global.ysf("url", { templateId: 4469118 });
              } else {
                global.ysf("open", { templateId: 4469118 });
              }
            },
            error() {
              // 错误回调
              console.log("error");
            }
          });
      } else {
        alert("在线客服sdk尚未加载成功，请稍后再试");
      }
    },
    toLoginVCG() {
      return Axios.post("http://vdam-gateway-service.fotomore.com/user/login", {
        userName: this.userName,
        password: this.userPassword
      });
    },
    toPeoplePicture() {
      var peopleWeb = `http://vip.people.com.cn/`;
      window.open(peopleWeb);
    },
    toVCG() {
      // var personalUrl = `http://vips.vcg.com/?token=${localStorage.getItem(
      //   "vcgtoken"
      // // )}`;
      // var personalUrl = `http://vips.vcg.com/?token=${localStorage.getItem(
      //   "vcgtoken"
      // )}`;

      // var personalUrl = `http://vips.vcg.com/freeLoginForVcgUser?token=${localStorage.getItem(
      //   "vcgtoken"
      // )}`;
      var personalUrl = `http://vips.fotomore.com/freeLoginForVcgUser?token=${localStorage.getItem(
        "vcgtoken"
      )}`;

      window.open(personalUrl, "_blank").location;
    },
    judgeHelp() {
      if (this.$route.path == "/modelsix") {
        this.isModelSix = true;
      } else {
        this.isModelSix = false;
      }
      if (this.$route.path == "/login" || this.$route.path == "/lyLogin") {
        this.hiddenNav = false;
      } else {
        this.hiddenNav = true;
      }
      var vcgtk = localStorage.getItem("vcgtoken");
      if (vcgtk) {
        this.isVCGPermission = true;
      }
    },
    async getSiteChild() {
      // 根据域名判断是否为子站点
      var siteData = await getSiteLogin({ domainName: window.location.host });

      if (siteData) {
        var webLoginUserId = siteData.data.web_login_user_id;
        var webSiteId = siteData.data.web_site_id;

        if (webLoginUserId) {
          //子站点直接登录
          var loginData = await loginThrougUser({ user_id: webLoginUserId });
          var localtoken = sessionStorage.getItem("token");

          if (loginData) {
            // 设置
            sessionStorage.setItem("token", loginData.data.token);

            this.changeSite(true);

            this.ifChildSite = this.showSite;
          }
        } else {
          //非子站点
        }

        var localtoken = sessionStorage.getItem("token");
        if (localtoken) {
          console.log("Home Created");
          let option = {
            headers: {
              Authorization: "Bearer " + localtoken
            }
          };
          let resUserInfo = await getUserInfo(option);

          if (resUserInfo.status_code == 1) {
            sessionStorage.setItem("user", JSON.stringify(resUserInfo.data));
            this.setLoginSign();

            // if (res.data.is_vcg == 1) {
            //   let result = await this.toLoginVCG();
            //   if (result.status == 200 && result.data.status == "200") {
            //     if (result.data.TGT) {
            //       sessionStorage.setItem("vcgtoken", result.data.TGT);
            //     }
            //   }
            // }

            if (
              resUserInfo.data.user_type == 6 ||
              resUserInfo.data.user_type == 7
            ) {
              this.picshow = true;
            } else {
              this.picshow = false;
            }
          } else {
            window.location.href = window.location.href.split("?")[0];
          }
          this.setLoginSign(true);

          // getUserInfo(localtoken).then(res => {
          //   console.log(111)
          //   console.log(res)
          // if (res.data.user_type == 6 || res.data.user_type == 7) {
          //   this.picshow = true;
          // } else {
          //   this.picshow = false;
          // }
          // });
        }
      }
    },
    getdoctitle() {
      getdoctitle({ uid: this.webID }).then(x => {
        // debugger;
        if (x.status_code == 1) {
          let oauth_status = x.data.oauth_status;
          sessionStorage.setItem("switches", JSON.stringify(x.data.switches));
          sessionStorage.setItem(
            "serviceUrl",
            JSON.stringify(x.data.appLimitOptions.serviceUrl)
          );
          if (oauth_status == 1) {
            //接入
            this.isOuthtoken = true;
            let oauth_token_url = x.data.oauth_token_url;

            // 存入sessionStorage
            sessionStorage.setItem(
              "oauthTokenUrl",
              JSON.stringify(oauth_token_url)
            );
            this.redictUrl = `https://login.ihep.ac.cn/oauth2/authorize?response_type=code&redirect_uri=${oauth_token_url.domain}&client_id=${oauth_token_url.client_id}&theme=full/simple/embed"`;
            //
          } else {
            //未接入
          }
        }
      });
    },
    getPathByTplId(item) {
      switch (item.tpl_id) {
        case 1:
          return "modeltwo";
        case 2:
          return "modelone";
        case 3:
          return "modelthree";
        case 4:
          return "special";
        case 10:
          return "loginbf";
        case 7:
          return "service";
        case 8:
          return "recommend";
        case 9:
          return "aboutus";
        case 6:
          return "modelad";
        case 11:
          return "allclassnew";
        case 13:
          return "modeltwonew";
        case 14:
          return "taskCollection";
        case 29:
          return "modelsix";
        case 30:
          return "categoryPageLy";
        case 31:
          return "adminOverview";
        case 32:
          return "categoryCustomPageLy";
        case 33:
          return "essence";
        case 34:
          return "modelvideo";
        case 35:
          // 视觉长安 未登录模板
          return "noLoginModel";
        case 36:
          // 视觉长安 已登录模板
          return "loginModel";
        case 37:
          // 视觉长安 创意摄影
          return "creativePhoto";
        case 38:
          // 视觉长安 视频
          return "modelvideo2";
        case 39:
          // 创意视频
          return "modelvideo3";
        case 40:
          // 微电影
          return "modelvideo4";
        case 41:
          // 地域列表
          return "territoryList";
        case 42:
          // 地域列表2
          return "territoryListLocal";
        case 43:
          // 人民视觉
          return "peoplevisual";
      }
    },
    keyevent() {
      var that = this;
      document.onkeydown = function(e) {
        //按下键盘
        that.keyI = e.keyCode;
      };
    },
    gofirstPage() {
      this.setCurModelInfo(this.modelsInfo[0]);
      this.setActiveChanelIndex(0);
      sessionStorage.setItem("first", 0);

      if (this.showPeople) {
        if (this.userInfo) {
          this.$router.push({ path: "/" + this.modelsInfo_real[0].path });
        } else {
          this.$router.push({ path: "/peoplevisual" });
        }
      } else {
        this.$router.push({ path: "/" + this.modelsInfo_real[0].path });
      }
    },
    signOut() {
      this.userInfo = false;
      signOut().then(res => {
        localStorage.removeItem("user");
        localStorage.removeItem("token");
        sessionStorage.removeItem("user");
        sessionStorage.removeItem("token");
        localStorage.removeItem("vcgtoken");
        this.isVCGPermission = false;
        this.setLoginSign(false);

        this.$message.success("退出成功");
        window.location.href = "https://login.ihep.ac.cn/logout";
      });
    },
    changeModel(module, index) {
      // ;
      console.log("-----------------------");
      console.log(module, index);
      sessionStorage.setItem("moduleInfo", JSON.stringify(module)); //点击各个菜单导航的信息
      this.setCurModelInfo(module);
      this.setActiveChanelIndex(index);
      sessionStorage.setItem("first", index);
      this.$router.push({ path: module.path });
    },
    toSearch() {
      this.$router.push({
        path: "/search",
        query: {
          type: this.select,
          text: encodeURI(this.searchText)
        }
      });
    },

    toPersonal() {
      var personalUrl = "";
      var token = sessionStorage.getItem("token");
      if (window.location.origin.includes("ihep.ac")) {
        personalUrl = `${window.location.origin}:8000/#/login?token=${token}&activename=name1`;
      } else {
        // else if (window.location.origin.includes("pre.saas")) {
        //   personalUrl = `http://pre.my.saas.vcg.com/?token=${token}`;
        // } else if (window.location.origin.includes("test.saas")) {
        //   personalUrl = `http://test.my.saas.vcg.com/?token=${token}`;
        // }
        personalUrl = `http://${
          JSON.parse(sessionStorage.getItem("serviceUrl")).myCenter
        }/?token=${token}`;
      }
      window.open(personalUrl, "_blank").location;
    },
    getModuleInfo() {
      getModuleInfo({
        module_id: 40,
        web_id: this.webID
      }).then(res => {
        if (res.status_code == 1) {
          this.mustLogin = res.data.list[0].login_index == 1 ? true : false;

          sessionStorage.setItem("mustLogin", this.mustLogin);
        }
      });
      this.userInfo = sessionStorage.getItem("user")
        ? JSON.parse(sessionStorage.getItem("user"))
        : false;
      var id = setInterval(() => {
        if (this.$store.getters.webModels.module_data) {
          clearInterval(id);
          var logo = this.webModels.module_data.find(item => {
            if (item.title == "logo") return item;
          });
          var homeColor = this.webModels.module_data.find(item => {
            if (item.title == "首页底色") return item;
          });
          let data = {
            module_id: logo.id,
            web_id: this.webID,
            use_sort_num: 1,
            sort: "asc"
          };
          getModuleInfo(data, {
            page: 1,
            page_nums: logo.rows_num
          }).then(res => {
            if (res.status_code == 1) {
              this.logo = {
                id: logo.id,
                list: res.data.list
              };
            }
          });
          data.module_id = homeColor.id;
          //
          getModuleInfo(
            { module_id: 5, use_sort_num: 1, sort: "asc" },
            null
          ).then(res => {
            if (res.status_code == 1) {
              this.homeColor = {
                id: homeColor.id,
                list: res.data.list
              };
              this.homeheaderbgcolor = pbmethod.colorRgb(
                this.homeColor.list[0].body
              );
            }
          });

          data = {
            module_id: 23,
            web_id: this.webID,
            use_sort_num: 1,
            sort: "asc"
          };
          getModuleInfo(data).then(res => {
            if (res.status_code == 1) {
              switch (res.data.list[0].nav) {
                case 1:
                  this.navpos = "flex-start";
                  break;
                case 2:
                  this.navpos = "center";
                  break;
                case 3:
                  this.navpos = "flex-end";
                  break;
              }
              this.isshowSidebar = eval(res.data.list[0].body4);
              this.sidebarQQ = res.data.list[0].body5;
              this.sidebarTel = res.data.list[0].body6;
              this.sidebarTime = res.data.list[0].body7;
            }
          });
        }
      }, 0);
    },
    toDam(id) {
      var token = sessionStorage.getItem("token");
      if (token) {
        var nm = id == 1 ? "name1" : "name2";
        window.open(
          `http://${
            JSON.parse(sessionStorage.getItem("serviceUrl")).damManage
          }/#/login?token=` +
            token +
            "&activename=" +
            nm
        );
      } else {
        this.$router.push({
          path: "/login"
        });
      }
    },
    mouseoverT() {
      this.TelInfoShow = true;
    },
    mouseoutT() {
      this.TelInfoShow = false;
    },
    mouseoverC() {
      this.collectionShow = true;
    },
    mouseoutC() {
      this.collectionShow = false;
    },
    mouseoverD() {
      this.downloadShow = true;
    },
    mouseoutD() {
      this.downloadShow = false;
    },
    mouseoverQQ() {
      this.qqcom = true;
    },
    mouseoutQQ() {
      this.qqcom = false;
    },
    mouseoverService() {
      this.downloadShow = true;
    },
    mouseoutService() {
      this.downloadShow = false;
    },

    mosewheel(event) {
      let scrolltop =
        document.body.scrollTop ||
        document.documentElement.scrollTop ||
        window.pageYOffset;
      if (scrolltop == 0) {
        this.opacity = "0.68";
      } else {
        this.opacity = "1";
      }
    }
  },
  components: {
    recommend,
    valueaddservice,
    aboutUs,
    modelOne,
    modelTwo,
    modelThree,
    topic,
    modelAdBeforeLogin,
    modelAd,
    homeHeader,
    allClassification,
    modelTwoNew,
    ChanganNav
  }
};
</script>
<style lang="less" scoped>
.peoplePicture:hover {
  text-decoration: underline;
  color: rgba(215, 0, 15, 1);
}
.homeCon {
  display: flex;
  display: -webkit-flex;
  .activeSty {
    color: #333;
    // font-weight: bold;
    font-size: 16px;
  }
  .noactiveSty {
    color: #333;
    font-size: 13px;
  }
  .disable {
    color: rgba(121, 7, 7, 0.3);
  }
  .nav-content {
    li {
      margin-left: 40px;
      a {
        font-weight: 600;
        font-family: "PingFangSC-Regular", "Microsoft YaHei", "微软雅黑",
          "MicrosoftJhengHei", sans-serif, "-apple-system", "BlinkMacSystemFont",
          "Segoe UI", "Roboto", "Helvetica Neue", Arial, "Noto Sans", sans-serif,
          "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol",
          "Noto Color Emoji";
      }
      a:hover {
      }
    }
  }
  .people-header-mourning {
    width: 100%;
    height: 80px;
    align-items: center;
    text-align: center;
    background: rgba(8, 8, 8, 1);
    position: relative;
    background: #111;
    color: #fff;
    font-size: 24px;
    padding: 24px 24px;
    line-height: 24px;

    i {
      position: absolute;
      width: 24px;
      height: 24px;
      right: 20px;
      top: 28px;
      cursor: pointer;
      color: #666666;
    }
  }
  .people-header {
    width: 100%;
    height: 60px;
    background: rgba(255, 0, 0, 1);
    display: flex;
    align-items: center;
    div {
      width: 1200px;
      margin: 0 auto;
      img {
        align-items: center;
      }
    }
  }
  .homeHeaderCon {
    @media screen and (max-width: 750px) {
      height: 3.4rem;
    }
    width: 100%;
    height: 70px;
    padding-left: 0px;
    padding-right: 0px;
    margin-right: auto;
    margin-left: auto;
  }
  .homeHeaderP {
    width: 100%;
    height: 70px;
    .homeHeader {
      @media screen and (max-width: 750px) {
        width: auto;
        overflow-x: auto;
        overflow-y: hidden;
        height: 3.4rem;
      }
      margin: 0 auto;
      max-width: 1200px;
      height: 70px;
      display: flex;
      display: -webkit-flex;
      justify-content: space-between;
      z-index: 1000;
      .logo {
        height: 100%;
        width: 120px;
        display: flex;
        align-items: center;
        justify-content: center;

        .beijing2022 {
          max-height: 60px;
          // margin-left: 800px;
        }
        .other {
          max-width: 120px;
          max-height: 60px;
        }
      }
      .otherCon {
        display: flex;
        display: -webkit-flex;
        align-items: center;
        width: calc(100% - 120px);
        @media screen and (max-width: 750px) {
          width: auto;
        }
        .nav {
          height: 100%;
        }
      }

      .nav {
        margin-right: 20px;
        min-width: 200px;
        .nav-content {
          @media screen and (max-width: 750px) {
            width: auto;
            a {
              font-size: 1rem;
              color: #080808;
              height: 1.5rem;
              line-height: 1.5rem;
              font-weight: 500;
              font-family: "PingFangSC-Regular", "Microsoft YaHei", "微软雅黑",
                "MicrosoftJhengHei", sans-serif, "-apple-system",
                "BlinkMacSystemFont", "Segoe UI", "Roboto", "Helvetica Neue",
                Arial, "Noto Sans", sans-serif, "Apple Color Emoji",
                "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
            }
          }
          display: flex;
          height: 20px;
          font-size: 14px;
          font-family: PingFang-SC-Medium;
          line-height: 20px;
          height: 100%;
          // padding-top: 24px;
          justify-content: flex-start;

          li {
            @media screen and (max-width: 750px) {
              width: auto;
              height: 3.4rem;
              line-height: 3.4rem;
              white-space: nowrap;
            }
            color: rgba(44, 62, 76, 1);
            display: flex;
            display: -webkit-flex;
            align-items: center;
            a.sjcaLine {
              height: 100%;
              line-height: 70px;
              font-size: 14px;
            }
            a.sjcaLine.activeSty {
              border-bottom: 4px solid #fff;
            }
            a.sjcaLine:hover {
              border-bottom: 4px solid #fff;
            }
          }
        }
      }
      .search {
        width: 345px;
        height: 40px;
        margin-right: 40px;
        display: flex;
        .el-select {
          padding-right: 0;
          width: 150px;
        }
        .el-button {
          background-color: #f05941;
          color: #fff;
          padding: 0px;
          height: 40px;
          width: 40px;
          font-size: 20px;
        }
        .el-input-group {
          width: 250px;
        }
      }
      .loginBtn {
        width: 98px;
        height: 40px;

        border-radius: 3px;
        .btnContent {
          line-height: 20px;
          height: 20px;
          width: 85px;
          margin-top: 10px;
          margin-left: 8px;
          display: flex;
          -ms-flex-pack: justify;
          justify-content: space-between;

          a {
            color: #333;
            font-size: 14px;
          }
          a:hover {
            color: red;
          }
        }
      }
      .userInfo {
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        .personLogo {
          display: flex;
          display: -webkit-flex;
        }
        span {
          font-size: 16px;
          // line-height: 45px;
          cursor: pointer;
          vertical-align: middle;
          display: flex;
          display: -webkit-flex;
          align-items: center;
        }
        .userHead {
          margin-left: 10px;
          display: inline-block;
          width: 45px;
          height: 45px;
          vertical-align: middle;
          cursor: pointer;
          img {
            width: 100%;
            height: 100%;
            border-radius: 50%;
          }
        }
      }

      .homeHeaderTwo {
        width: 100%;
        height: 70px;
        position: fixed;
        display: flex;
        z-index: 1000;
        .logo {
          height: 100%;
          width: 120px;
          color: #fff;
          display: flex;
          justify-content: center;
          align-items: center;
          img {
            max-width: 100%;
            max-height: 100%;
          }
        }
      }
    }
  }
  .homeHeaderP.transP {
    position: absolute !important;
    z-index: 900 !important;
    background: transparent !important;
    .nav-content {
      .noactiveSty {
        color: white;
      }
      .activeSty {
        color: white;
      }
    }
    .loginBtn {
      .loginbtn-item {
        a {
          color: white;
        }
      }
    }
  }
  .righttoolbal {
    @media screen and (max-width: 750px) {
      display: none;
    }
    width: 30px;
    background-color: #212121;
    z-index: 9999;
    color: white;
    .itemcon {
      position: fixed;
      top: 300px;
      width: 30px;
      .tel {
        background-color: red;
        position: relative;
        height: 100px;
        .telinfo {
          background-color: white;
          position: absolute;
          left: -150px;
          top: 0px;
          bottom: 0px;
          right: 30px;
          color: #757575;
          padding-left: 20px;
          padding-top: 10px;
          border: 1px solid rgba(0, 0, 0, 0.1);
        }
      }
      .collection {
        margin-top: 20px;
        position: relative;
        .collec {
          background-color: red;
        }
        .collectioninfo {
          background-color: red;
          position: absolute;
          left: -100px;
          top: 0px;
          bottom: 0px;
          right: 30px;
          line-height: 24px;
          padding-left: 10px;
          text-align: center;
        }
      }
      .download {
        margin-top: 20px;
        position: relative;
        .jilu {
          background-color: red;
        }
        .downloadinfo {
          background-color: red;
          text-align: center;
          position: absolute;
          left: -100px;
          top: 0px;
          bottom: 0px;
          right: 30px;
          line-height: 24px;
          padding-left: 10px;
          cursor: pointer;
        }
      }
      .txqq {
        margin-top: 20px;
        color: white;
        .txqqcon {
          position: relative;
          .qq {
            background-color: red;
          }
          .qqcom {
            background-color: red;
            color: white;
            position: absolute;
            left: -100px;
            top: 0px;
            bottom: 0px;
            right: 30px;
            line-height: 24px;
            padding-left: 10px;
          }
        }
      }
    }
  }
  .home {
    flex: 1;
    max-width: 100%;
    overflow: hidden;
  }
  .allChose {
    .el-checkbox__inner {
      width: 24px;
      height: 24px;
    }
  }
}

.mourningGrey {
  -webkit-filter: grayscale(100%);
  -moz-filter: grayscale(100%);
  -ms-filter: grayscale(100%);
  -o-filter: grayscale(100%);
  filter: grayscale(100%);
  filter: gray;
}
</style>

<style lang="less">
.blackbg,
.picFlow,
.groupShow {
  a img {
    transition: 0.5s;
    overflow: hidden;
    display: inline-block;
    position: relative;
    transition: 0.2s;
  }
}
.blackbg,
.picFlow,
.groupShow {
  a .mask-layer {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: #000;
    color: #ffffff;
    opacity: 0;
  }
}
.blackbg,
.picFlow,
.groupShow {
  a img:hover {
    transform: scale(1.1);
  }
}
.blackbg,
.picFlow,
.groupShow {
  a:hover .mask-layer {
    opacity: 0.3;
  }
}

.minutes-father {
  video {
    background: #000;
  }
}

.el-dropdown-menu__item:focus,
.el-dropdown-menu__item:not(.is-disabled):hover {
  background-color: #eff0f7;
  color: #606266;
}
</style>



// WEBPACK FOOTER //
// src/page/Home.vue